<template>
    <div class="pt-10 cuform">
        <TwoColumnLayout>
            <template v-slot:banner>
                <Banner :data="getBrandBanner()" :single="true" />
            </template>
            <template v-slot:title>
                
            </template>
            <template v-slot:filters>
            </template>
            <template v-slot:form-content>
                <h2 class="mt-4 mt-sm-0">Please enter the information below:</h2>
                <contact-details />
            </template>
            <template v-slot:address>
                <contact-address />
            </template>
        </TwoColumnLayout>
    </div>
</template>
<script>
    import ContactAddress from "../components/molecules/ContactAddress.vue";
    import TwoColumnLayout from "../components/molecules/TwoColumnLayout.vue";
    import ContactDetails from "../components/InputForms/ContactDetails.vue";
    import Banner from '../components/molecules/CarouselBanner.vue';
    import getBannerData from '../constants/banner.config';
    export default {
        name: "ContactUS",
        components: {
            ContactAddress,
            TwoColumnLayout,
            ContactDetails,
            Banner
        },
        data() {
            return {
            };
        },
        methods:{
            getBrandBanner(){
                return getBannerData(sessionStorage.getItem('brand'), 'contact_us');
            },
        }
    };
</script>